(function () {
document.querySelectorAll('.categorytabs-headings p').forEach((heading, index) => {
  heading.addEventListener('click', () => {
    document.querySelectorAll('.categorytabs-headings p, .categorytab').forEach(el => el.classList.remove('active'));
    heading.classList.add('active');
    document.querySelectorAll('.categorytab')[index].classList.add('active');
  });
});
// IPAD TABS FOR PRODUCT PAGE & // Mobile TABS FOR PRODUCT PAGE
const toggleTab = (tab, height) => {
  tab.classList.toggle('active');
  tab.style.height = tab.classList.contains('active') ? tab.scrollHeight + 'px' : height;
};
const initTabs = (selector, height) => {
  document.querySelectorAll(selector).forEach((tab, index) => {
      tab.addEventListener('click', () => toggleTab(tab, height));
      if (index === 0 && !tab.classList.contains('active')) toggleTab(tab, height);
  });
};
initTabs('.prodDescIpad .prod-tab', '6.235vw');
initTabs('.prodDescMob .prod-tab', '48px');
window.addEventListener('resize', () => {
  document.querySelectorAll('.prodDescIpad .prod-tab, .prodDescMob .prod-tab').forEach(tab => {
      tab.classList.contains('active') ? tab.style.height = tab.scrollHeight + 'px' : tab.style.height = tab.classList.contains('prodDescIpad') ? '6.235vw' : '48px';
  });
});})();